module.exports = __webpack_public_path__ + "img/watermark.c3f3e97a.png";